<template>
  <v-dialog :value="open" width="60rem" persistent>
    <v-card :style="{ maxHeight: '454px !important', overflow: 'auto' }">
      <v-card-title>
        <v-layout :style="{ margin: '-0.5rem' }" align-center>
          <v-flex class="headline pa-2"> Search </v-flex>
          <v-flex class="pa-2" shrink>
            <v-btn icon @click="handleCloseButtonClick">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg :style="{ width: '100% !important' }">
          <v-layout wrap>
            <v-flex xs12>
              <div class="caption">Date</div>
              <DateFilter
                ref="dateFilter"
                v-model="localValue.dateRange"
                :default-filter="localValue.dateRange.filter"
                :hide-search="true"
              />
            </v-flex>
            <v-flex xs12 md6 class="default-input">
              <div class="caption">Name</div>
              <v-text-field
                v-model="localValue.name"
                single-line
                outline
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <div class="caption">Page</div>
              <v-radio-group v-model="localValue.page" row>
                <v-radio
                  v-for="(option, index) in pageOptions"
                  :key="index"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 md6>
              <div class="caption">Sentiment</div>
              <v-select
                v-model="localValue.sentiment"
                :items="sentimentOptions"
                single-line
                outline
                hide-details
              ></v-select>
            </v-flex>
            <v-flex v-if="localValue.sentiment == 'nagative'" xs12 md6>
              <div class="caption">Total negative</div>
              <v-radio-group v-model="localValue.totalNegative" row>
                <v-radio
                  v-for="(option, index) in totalNegativeOptions"
                  :key="index"
                  :label="option.text"
                  :value="option.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <div class="ml-auto">
          <v-btn @click="handleClearSearchButtonClick">
            <v-icon>clear</v-icon>
            Clear search
          </v-btn>
          <v-btn color="primary" @click="handleSearchButtonClick">
            <v-icon>search</v-icon>
            Search
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { DATETIME } from '@/constants/datetime'
import { SENTIMENT_LIST } from '@/constants/sentiment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'

export default {
  components: {
    DateFilter
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localValue: {
        dateRange: {
          start: moment().format(DATETIME.DATE_FORMAT),
          end: moment().format(DATETIME.DATE_FORMAT),
          filter: 'today'
        },
        name: '',
        sentiment: '',
        page: '',
        totalNegative: '',
        ...this.value
      },
      pageOptions: [
        { value: 'all', text: 'All' },
        ...this.$store.state.botlist.map((item) => ({ value: item.pageid, text: item.pagename }))
      ],
      sentimentOptions: [{ value: '', text: 'All' }, ...SENTIMENT_LIST],
      totalNegativeOptions: [
        { value: '', text: 'All' },
        { value: 'gte_4', text: 'มากกว่าหรือเท่ากับ 4' }
      ]
    }
  },
  watch: {
    value(value) {
      this.localValue = value
    }
  },
  methods: {
    handleCloseButtonClick() {
      this.$emit('update:open', false)
    },
    handleClearSearchButtonClick() {
      this.$emit('input', {
        dateRange: {
          start: moment().format(DATETIME.DATE_FORMAT),
          end: moment().format(DATETIME.DATE_FORMAT),
          filter: 'today'
        },
        name: '',
        sentiment: '',
        page: '',
        totalNegative: ''
      })
      this.$emit('update:open', false)
    },
    handleSearchButtonClick() {
      this.$refs.dateFilter.emitDateTime()
      this.$emit('input', JSON.parse(JSON.stringify(this.localValue)))
      this.$emit('update:open', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/SearchDialog.vue